import React, { FC, useEffect, useState } from 'react'
import { inject } from 'mobx-react'
import { FaTimes, FaBullseye } from 'react-icons/fa'
import { ClickAwayListener, Grow, Paper, Popper, ListItemText } from '@material-ui/core'
import API from '@aws-amplify/api'
import { Prospects as ProspectsStore } from '../../../../stores/prospects'
import { Search as SearchStore } from '../../../../stores/search'
import Spinner from '../../../Spinner'
import { ranks } from '../../../../utils/constants'
import './styles.scss'

interface Props {
  prospects: ProspectsStore
  // eslint-disable-next-line react/require-default-props
  search?: SearchStore
  openRankPopper: boolean
  anchorRef: React.RefObject<HTMLButtonElement>
  setOpenRankPopper: (value: boolean) => void
}
const RankPopper: FC<Props> = ({
  prospects,
  search,
  anchorRef,
  openRankPopper,
  setOpenRankPopper,
}) => {
  const [rankType, setRankType] = useState(prospects?.prospect?.rank)

  const handleCloseRankPopper = (event?: React.MouseEvent<EventTarget>): void => {
    if (anchorRef.current && anchorRef.current.contains(event?.target as HTMLElement)) {
      return
    }

    setOpenRankPopper(false)
  }
  const prevOpen = React.useRef(openRankPopper)
  useEffect(() => {
    if (prevOpen.current === true && openRankPopper === false) {
      anchorRef?.current?.focus()
    }

    prevOpen.current = openRankPopper
  }, [openRankPopper])
  const toRank = async (rank: string): Promise<void> => {
    const newRank = rank
    try {
      const payload = {
        rank: newRank,
        leadId: prospects?.prospect?.id,
      }
      const myInit = { body: payload }
      await API.put('mav-outlook-api', `/leads/${prospects?.prospect?.email}`, myInit)
    } catch (e) {
      console.error(e)
    }
    // search?.getProspects()
    const data = {}
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const id: any = prospects?.prospect?.id
    data[id] = { rank: newRank }
    search?.updateProspectsData(data)

    prospects?.getLead(prospects?.prospect?.email)
  }
  const handleRankChange = (index): void => {
    setRankType(ranks[index])
    setOpenRankPopper(false)
    toRank(ranks[index])
  }

  if (prospects?.isLoading) {
    return <Spinner />
  }
  if (!prospects?.prospect) {
    return null
  }
  return (
    <Popper
      open={openRankPopper}
      anchorEl={anchorRef.current}
      role={undefined}
      transition
      disablePortal
      style={{
        zIndex: 1,
      }}
    >
      {({ TransitionProps, placement }): JSX.Element => (
        <Grow
          {...TransitionProps}
          style={{
            transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom',
          }}
        >
          <Paper className="rank-popup" style={{ maxWidth: 400, float: 'right' }}>
            <ClickAwayListener onClickAway={handleCloseRankPopper}>
              <div className="rank-form">
                <ListItemText>
                  <FaBullseye />
                  Select a new rank.
                </ListItemText>
                <FaTimes
                  className="rank-form-close"
                  onClick={(): void => setOpenRankPopper(false)}
                />
                <div className="rank-type-container">
                  {ranks.map((rank, index) => (
                    <>
                      <ListItemText
                        className={`rank-item ${rankType === rank ? 'current' : ''}`}
                        onClick={(): void => handleRankChange(index)}
                      >
                        {rank}
                      </ListItemText>
                    </>
                  ))}
                </div>
              </div>
            </ClickAwayListener>
          </Paper>
        </Grow>
      )}
    </Popper>
  )
}

export default inject('prospects', 'related', 'search', 'companyInfo')(RankPopper)
